export default (rawRsvpData, guestlist) => {
    const out = _.cloneDeep(rawRsvpData);

    delete out.changelog;

    const fieldsToCheckAndDelete = [
        'contact',
        'last_message',
        'guestlist',
        'invoices',
        'last_change',
        'seatplan_area',
        'area_config',
        'info_document'
    ];

    _.each(fieldsToCheckAndDelete, (field) => {
        if (!_.isUndefined(out[field])) {
            delete out[field];
        }
    });

    if (!_.isUndefined(out.relations)) {
        _.each(out.relations, (v, relationTypeUuid) => {
            out.relations[relationTypeUuid] = _.get(v, `${_.first(Object.keys(v))}.id`, null);
        })
    }

    const customFieldDefinitionRegex = new RegExp("custom_([0-9]{1,2})_name");
    _.each(guestlist, (value, field) => {
        if (!_.isEmpty(value) && field.match(customFieldDefinitionRegex)) {
            const customFieldNumber = _.get(customFieldDefinitionRegex.exec(field), '1');
            switch (_.get(value, 'type', value)) {
                case 'media_image':
                case 'media_file':
                    _.set(out, 'custom_' + customFieldNumber, _.get(out, 'custom_' + customFieldNumber + '.uuid', null));
                    break;
            }
        }
    });

    if (!_.isUndefined(out.booked_objects)) {
        out.bookable_objects = prepareBookedObjectsForForm(out.booked_objects);
        delete out.booked_objects;
    }

    if (!_.isUndefined(out.seatplan_elements)) {
        _.each(out.seatplan_elements, (seatplanElement, seatplanElementKey) => {
            seatplanElement.bookable_objects = prepareBookedObjectsForForm(seatplanElement.booked_objects);
            delete seatplanElement.booked_objects;
        });
    }

    return out;
}

function prepareBookedObjectsForForm(objects) {
    const out = {};
    _.each(objects, (object) => {
        if (!object.options) {
            return;
        }
        const objectUuid = object.object.uuid;

        _.each(object.options, (option) => {
            const optionUuid = option.option.uuid;

            if (object.object.type === 'day_range_bookings') {
                if (!out[objectUuid]) {
                    out[objectUuid] = [];
                }

                _.each(option.option_links, (optionLink) => {
                    out[objectUuid].push({
                        uuid: optionLink.uuid,
                        option_uuid: option.option.uuid,
                        start_date: optionLink.start_date,
                        end_date: optionLink.end_date
                    });
                });
            } else if (object.object.type === 'time_reserved') {
                if (!out[objectUuid]) {
                    out[objectUuid] = [];
                }

                _.each(option.option_links, (optionLink) => {
                    out[objectUuid].push({
                        uuid: optionLink.uuid,
                        option_uuid: option.option.uuid,
                        start_time: optionLink.start_time,
                        end_time: optionLink.end_time,
                        location: optionLink.location,
                        device_name: optionLink.device_name,
                    });
                });
            } else {
                if (!out[objectUuid]) {
                    out[objectUuid] = {};
                }
                out[objectUuid][optionUuid] = option.option_links[0].amount;
            }
        });
    });

    return out;
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/helpers/rsvp-model-reducer.js